module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Semibold.1d0f405014daad0066213999a72a9541.woff";